export default __webpack_public_path__ + "static/media/upIcon.3e9da6a1.svg";